<template>
  <header class="header public" :class="small ? 'header__small' : ''">
    <div class="flex justify-center md:gap-3 mx-3 md:items-center md:content-center		">
      <router-link
        :to="{ name: 'home' }" class="flex flex-row  justify-center md:gap-3 mx-3 md:items-center md:content-center	"
        title="Revenir à l'accueil"
      >
        <div>
          <img
            class="logo"
            src="@/assets/images/logo_Index_acta.png"
            alt="logo index-acta"
          />
        </div>
        <div>
          <span class="text-center orange hidden xl:block">
            La référence en protection des plantes
          </span>
        </div>
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeadTitle',
  props: {
    small: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss">
.header.public.header__small {
  .logo {
    height: 48px;
  }
  .name-container {
    padding: 14px 0;
    .name {
      font-size: 1em;
    }
  }
}

.header.public {
  .logo {
    height: 80px;
  }
  .name-container {
    padding: 20px 0;
    .name {
      font-size: 1.5em;
    }
  }
}
</style>
